// Make sure to prefix the mutation names with the module to avoid collisions
export const USER_SET_ABILITIES = 'userSetAbilities'